export default {
	searchParams: {
		partNm: '',
		bomType: '10'
	},
	bomInfo: [],
	gridList: [],
	pagingInfo: {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	}
};
